export default __webpack_public_path__ + "7f470445f56062d16715f4472448deec.png";